import { render, staticRenderFns } from "./PodDataStream.vue?vue&type=template&id=963d1fb2&"
import script from "./PodDataStream.vue?vue&type=script&lang=js&"
export * from "./PodDataStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports